import VueStripeCheckout from './dist';

export default VueStripeCheckout;


//////////////////
// WEBPACK FOOTER
// ./~/vue-stripe-checkout/index.js
// module id = 1295
// module chunks = 1